import TextEditor from 'CMFW/input/TextEditor';
import { AudioPlayer } from 'CMFW/layout/AudioPlayer';
import { EditorRow } from 'components/common/styles';
import React, { useContext } from 'react';
import styled from 'styled-components';
import KeyContext from 'CMFW/context/KeyContext';
import ModuleContext from 'CMFW/context/ModuleContext';

const CK_EDITOR_CONFIG = {
  toolbar: [
    ['Undo', 'Redo'],
    ['Bold', 'Gap', 'RemoveFormat'],
    ['BulletedList', 'NumberedList', 'HorizontalRule', 'headings', 'title'],
  ],
  toolBarInline: [['Bold', 'Gap']],
};

type Props = {
  isListeningUpdated: boolean;
};

const SegmentDialect: React.FC<Props> = ({ isListeningUpdated }) => {
  const parentKey = useContext(KeyContext);
  const module = useContext(ModuleContext);
  const moduleItemValue = module.getItemUpdatedValue(parentKey);
  
  // Extract segment ID and dialect ID for unique key
  const segmentId = module.getItemId();
  const dialectId = moduleItemValue?.dialectId || 0;
  
  return (
    <Wrapper>
      <Container>
        <TextEditor keyName={'html'} clKeyName={'conceptLinkerConcepts'} keyError={'error'} config={CK_EDITOR_CONFIG} />
        {isListeningUpdated && <AudioPlayerStyled key={`audio-${segmentId}-${dialectId}`} />}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Container = styled(EditorRow)`
  flex-grow: 1;
`;

const AudioPlayerStyled = styled(AudioPlayer)`
  && {
    margin: 0 4px;
  }
`;

export default SegmentDialect;
